import React, { Component } from "react"
import ExpenseMonthlyDueDatesCardBasic from "components/expenseMonthlyDueDates/layout/ExpenseMonthlyDueDatesCardBasic"

export class ExpenseMonthlyDueDatesPageBasic extends Component {
    render() { return (<ExpenseMonthlyDueDatesCardBasic />) }
}
